import { useState } from "react";
import { ConfirmButton } from "@/components/common/ConfirmButton";
import { logout } from "@/lib/api";

/** 組織の接続元 IP 制限で API が拒否されたときに、画面全体を差し替えて理由を示す。 */
export function IpNotAllowedPage() {
	const [loggingOut, setLoggingOut] = useState(false);

	return (
		<div
			data-testid="ip-not-allowed-page"
			style={{
				minHeight: "100vh",
				background: "var(--surface-2)",
				display: "grid",
				placeItems: "center",
				fontFamily: "var(--font-sans)",
				padding: 24,
			}}
		>
			<div
				style={{
					width: "100%",
					maxWidth: 440,
					background: "var(--surface-1)",
					borderRadius: "var(--radius-5)",
					boxShadow: "var(--shadow-card)",
					padding: "40px 32px",
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					gap: 16,
					textAlign: "center",
				}}
			>
				<h1
					style={{
						margin: 0,
						fontSize: "var(--text-display)",
						fontWeight: 600,
						lineHeight: "var(--leading-snug)",
						letterSpacing: "var(--tracking-display)",
						color: "var(--fg-1)",
					}}
				>
					接続元が許可されていません
				</h1>
				<p
					style={{
						margin: 0,
						fontSize: "var(--text-ui)",
						color: "var(--fg-2)",
						lineHeight: "var(--leading-ui)",
					}}
				>
					この組織は許可された接続元からのみ利用できます。許可されたネットワークから接続し直してください。
				</p>
				<div style={{ display: "flex", gap: 8, marginTop: 8 }}>
					<ConfirmButton
						type="button"
						variant="outline"
						label="ログアウト"
						loading={loggingOut}
						onClick={() => {
							setLoggingOut(true);
							void logout();
						}}
						data-testid="ip-not-allowed-logout"
					/>
					<ConfirmButton
						type="button"
						label="再読み込み"
						loading={false}
						onClick={() => window.location.reload()}
						data-testid="ip-not-allowed-reload"
					/>
				</div>
			</div>
		</div>
	);
}
